import { Action } from "@ngrx/store";
import { IContext } from "../../context/models/context";
import { ContactUsModel } from "../models/contactus-model";
import { IManagementType } from "../../common/models/management-type";

export const LOAD = '[Contact Us] Load Overview Content';
export const LOAD_COMPLETE = '[Contact Us] Load Complete';
export const LOAD_ERROR = '[Contact Us] Load Error';

export const LOAD_ADMIN_DATA = '[Contact Us] Admin Data Load';
export const LOAD_ADMIN_DATA_COMPLETE = '[Contact Us] Admin Data Complete';
export const LOAD_ADMIN_DATA_ERROR = '[Contact Us] Admin Data Error';

export class Load implements Action {
  readonly type = LOAD;
  constructor(public context: IContext) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: ContactUsModel[]) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any) { }
}

export class LoadAdminData implements Action {
  readonly type = LOAD_ADMIN_DATA;
  constructor() { }
}
export class LoadAdminDataComplete implements Action {
  readonly type = LOAD_ADMIN_DATA_COMPLETE;
  constructor(public payload: IManagementType[]) { }
}

export class LoadAdminDataError implements Action {
  readonly type = LOAD_ADMIN_DATA_ERROR;
  constructor(public payload: any) { }
}

export type Actions =
  Load |
  LoadComplete |
  LoadError |
  LoadAdminData |
  LoadAdminDataComplete |
  LoadAdminDataError;
